<template>
  <b-modal
    ref="aboutModal"
    size="md"
    :title="$t('component.helpPopover.about')"
    centered
    modal-class="about-modal"
    static
    hide-footer
  >
    <b-container>
      <b-row class="w-100">
        <b-col class="d-flex flex-column align-items-center">
          <anapath-login-logo
            alt="AnaPath Logo"
            class="anapath-logo img-fluid p-2"
            aria-hidden="true"
          />
          <div class="mt-2 d-flex flex-column align-items-center">
            <span class="anapath-version label-dark">{{ $t('global.codeVersion') }} {{ version }}</span>
            <span class="anapath-copyright label-dark mt-1">{{ $t('component.aboutModal.copyright') }} &#169; 2019 - {{ getCurrentYear }} VITRO S.A</span>
          </div>
        </b-col>
      </b-row>
      <b-row class="w-100 mt-3 text-justify dark-text p-2">
        <b-col>
          <span class="secondary-color">{{ $t('component.aboutModal.legalText') }}:</span>
          <div class="mt-3">
            <ul>
              <li class="my-2">
                <b-button
                  class="btn__link"
                  href="#"
                  target_blank
                >
                  {{ $t('component.aboutModal.privacyPolicy') }}
                </b-button>
              </li>
              <li class="my-2">
                <b-button
                  class="btn__link"
                  href="#"
                  target_blank
                >
                  {{ $t('component.aboutModal.legalNotice') }}
                </b-button>
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import moment from 'moment'
import AnapathLoginLogo from '@/assets/images/svg/AnapathLoginLogo.vue'

export default {
    name: 'AboutModal',
    components: {
        AnapathLoginLogo
    },
    props: {
        sample: Object,
        isCaseValidated: Boolean
    },
    computed: {
        getCurrentYear() {
            return moment().format('YYYY')
        },
        version() {
            return this.$store.getters.parameters.global?.releaseVersion
        }
    },
    methods: {
        show() {
            this.$refs.aboutModal.show()
        },
        hide() {
            this.$refs.aboutModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .about-modal .anapath-logo {
        max-width: 260px;
    }
    .about-modal .logo-background {
        background: vt-color(white-light);
    }
    .about-modal .anapath-version {
        font-size: font-size(big);
        color: vt-color(dark-text);
        font-weight: bold;
    }
    .about-modal .anapath-copyright {
        font-size: font-size(very-normal);
        color: vt-color(dark-text);
    }
</style>
